export function getOpeningHoursForToday(store) {
  const days = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
  const now = new Date();
  const currentDayIndex = now.getDay(); // 0 = dimanche, 6 = samedi
  const currentHour = now.getHours() + now.getMinutes() / 60;

  const toFloatHour = (time) => {
    if (!time) return null;
    const [h, m] = time.split(":").map(Number);
    return h + m / 60;
  };

  const formatHour = (time) => time ? time.split(":").slice(0, 2).join(":") : null;

  // 🔁 On vérifie les 7 prochains jours à partir d'aujourd’hui
  for (let i = 0; i < 7; i++) {
    const dayOffset = (currentDayIndex + i) % 7;
    const dayIndex = dayOffset + 1;

    const open = store[`open_${dayIndex}`];
    const close = store[`close_${dayIndex}`];
    const pause = store[`pause_${dayIndex}`];
    const back = store[`back_${dayIndex}`];

    const openTime = toFloatHour(open);
    const closeTime = toFloatHour(close);
    const pauseTime = toFloatHour(pause);
    const backTime = toFloatHour(back);

    // ⏳ Si c’est aujourd’hui
    if (i === 0) {
      if (!openTime || !closeTime) continue;

      if (currentHour < openTime) {
        return {
          jour: days[dayOffset],
          ouverture: formatHour(open),
          fermeture: formatHour(close),
          pause: formatHour(pause),
          reprise: formatHour(back),
          prochaine_ouverture: formatHour(open)
        };
      }

      if (pauseTime && backTime && currentHour >= pauseTime && currentHour < backTime) {
        return {
          jour: days[dayOffset],
          ouverture: formatHour(open),
          fermeture: formatHour(close),
          pause: formatHour(pause),
          reprise: formatHour(back),
          prochaine_ouverture: formatHour(back)
        };
      }

      if (currentHour >= openTime && currentHour < closeTime) {
        return {
          jour: days[dayOffset],
          ouverture: formatHour(open),
          fermeture: formatHour(close),
          pause: formatHour(pause),
          reprise: formatHour(back),
          prochaine_ouverture: null
        };
      }

      // sinon trop tard dans la journée
    } else {
      // Prochaine ouverture dans les prochains jours
      if (openTime && closeTime) {
        return {
          jour: days[dayOffset],
          ouverture: formatHour(open),
          fermeture: formatHour(close),
          pause: formatHour(pause),
          reprise: formatHour(back),
          prochaine_ouverture: formatHour(open)
          // prochaine_ouverture: `${days[dayOffset]} à ${formatHour(open)}`
        };
      }
    }
  }

  // 🛑 Si aucun jour n’est ouvert
  return {
    jour: days[currentDayIndex],
    ouverture: "Fermé",
    fermeture: "Fermé",
    pause: null,
    reprise: null,
    prochaine_ouverture: null
  };
}



// console.log(`📅 Aujourd'hui (${horaires.jour})`);
// console.log(`🕒 Ouverture : ${horaires.ouverture}`);
// console.log(`🕓 Fermeture : ${horaires.fermeture}`);
// if (horaires.pause && horaires.reprise) {
//   console.log(`⏸️ Pause : ${horaires.pause} → Reprise à ${horaires.reprise}`);
// } else {
//   console.log("✅ Pas de pause aujourd'hui");
// }